import { Head } from "vite-react-ssg"

import { LegalPage } from "@/components/LegalPage"
import { useTermsAndConditions } from "@/lib/queries/legal"

/**
 * Terms & Conditions.
 *
 * Same shell as Privacy; different data source. Fetches from
 * `GET /app/tandc` after hydration.
 */
export function Component() {
  const query = useTermsAndConditions()
  return (
    <>
      <Head>
        <title>Terms &amp; Conditions — Good Talk</title>
        <meta
          name="description"
          content="The terms that govern your use of Good Talk."
        />
        <link rel="canonical" href="https://goodtalk.coach/terms" />
      </Head>
      <LegalPage title="Terms & Conditions" query={query} />
    </>
  )
}
